import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "gfu-reward-card__body" }
const _hoisted_2 = { class: "gfu-reward-card__content gfu-box__content" }
const _hoisted_3 = { class: "gfu-reward-card__title gfu-hd gfu-hd--h1 gfu-hd--decorative" }
const _hoisted_4 = {
  class: "gfu-price gfu-price--old _fw-n _ml-1",
  "data-qa": "price-type:Old"
}
const _hoisted_5 = {
  class: "_ml-1",
  "data-qa": "price-type:ThirtyDaysLowest"
}
const _hoisted_6 = {
  class: "gfu-reward-card__desc",
  "data-qa": "reward-box-element:Abstract"
}
const _hoisted_7 = { class: "_mt-2 _cf" }
const _hoisted_8 = {
  key: 1,
  class: "gfu-reward-card__stats _tc--dark-gray _flexwrap _col-gap-3 _row-gap-1 _mt-2"
}
const _hoisted_9 = {
  key: 0,
  class: "_flex"
}
const _hoisted_10 = {
  key: 1,
  class: "_flex"
}
const _hoisted_11 = { class: "_mx-1" }
const _hoisted_12 = {
  key: 0,
  class: "gfu-reward-card__info-bar",
  "data-qa": "reward-box-element:StretchPayInfo"
}
const _hoisted_13 = { class: "gfu-hd gfu-hd--h6" }
const _hoisted_14 = {
  class: "gfu-price _mr-1",
  "data-qa": "price-type:InstallmentCost"
}
const _hoisted_15 = {
  key: 1,
  class: "gfu-reward-card__action",
  "data-qa": "reward-box-action"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_base_image = _resolveComponent("base-image")
  const _component_router_link = _resolveComponent("router-link")
  const _component_display_currency_price = _resolveComponent("display-currency-price")
  const _component_localize = _resolveComponent("localize")
  const _component_content_renderer = _resolveComponent("content-renderer")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_display_currency_value = _resolveComponent("display-currency-value")
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_component_base_card, {
    id: $options.rewardCardID,
    orientation: "horizontal",
    class: "gfu-reward-card",
    "data-qa": `reward-box:${$props.productID}`
  }, {
    labels: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.badges, (badge) => {
        return (_openBlock(), _createBlock(_component_base_badge, {
          key: badge.name,
          class: "_mr-1 _my-1",
          theme: badge.theme,
          "data-qa": `reward-card-badge:${badge.dataQa}`
        }, {
          default: _withCtx(() => [
            (badge.icon)
              ? (_openBlock(), _createBlock(_component_base_icon, {
                  key: 0,
                  name: badge.icon
                }, null, 8 /* PROPS */, ["name"]))
              : _createCommentVNode("v-if", true),
            _createTextVNode(" " + _toDisplayString(badge.name), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["theme", "data-qa"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    media: _withCtx(() => [
      _createVNode(_component_router_link, {
        to: $options.route,
        class: "gfu-embed gfu-embed--1x1",
        onClick: $options.onRouteChange,
        "data-qa": "reward-box-element:Image"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_image, {
            class: "gfu-embed__item",
            loading: "lazy",
            src: $props.imageUrl,
            alt: $props.name
          }, null, 8 /* PROPS */, ["src", "alt"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "gfu-link gfu-link--nofx",
              to: $options.route,
              onClick: $options.onRouteChange,
              "data-qa": "reward-box-element:Name"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.name), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to", "onClick"])
          ]),
          _createVNode(_component_router_link, {
            to: $options.route,
            class: "gfu-reward-card__price gfu-link gfu-link--nofx",
            onClick: $options.onRouteChange,
            "data-qa": "product-price"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_display_currency_price, {
                "effective-price": $props.effectivePrice,
                "icon-classes": "gfu-icon--medium",
                price: $props.price,
                "is-discounted": $props.isDiscounted,
                class: "_flex _ai-c"
              }, {
                "effective-price": _withCtx(({ effectivePrice }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["gfu-price gfu-hd gfu-hd--h2", [{'gfu-price--discounted': $props.isDiscounted}]]),
                    "data-qa": "price-type:Effective"
                  }, _toDisplayString(effectivePrice), 3 /* TEXT, CLASS */)
                ]),
                price: _withCtx(({ price }) => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(price), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["effective-price", "price", "is-discounted"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to", "onClick"]),
          ($props.isDiscounted)
            ? (_openBlock(), _createBlock(_component_localize, {
                key: 0,
                resource: _ctx.Resources.Product.RewardCardLowestPriceInLast30Days,
                tag: "div",
                class: "_flex _ai-b gfu-bt gfu-bt--caption _tc--dark-gray"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_display_currency_price, {
                    "format-key": "0",
                    "icon-classes": "gfu-icon--small",
                    "effective-price": $props.effectivePrice,
                    price: $props.price,
                    tag: "span",
                    class: "_flexinline _ai-c"
                  }, {
                    "effective-price": _withCtx(({ effectivePrice }) => [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(effectivePrice), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["effective-price", "price"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["resource"]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: $options.route,
              class: "gfu-link gfu-link--nofx",
              "aria-label": $props.name,
              onClick: $options.onRouteChange
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.abstract), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to", "aria-label", "onClick"]),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gfu-reward-card__desc-fade" }, null, -1 /* CACHED */))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: $options.route,
              class: "gfu-link gfu-link--accent _fl",
              onClick: $options.onRouteChange,
              "data-qa": "reward-box-element:MoreInfo"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.Product.RewardCardMoreInfoLink) + " ", 1 /* TEXT */),
                _createVNode(_component_base_icon, {
                  name: "angle-right",
                  class: "gfu-icon gfu-icon--small gfu-icon--baseline _fr _ml-1"
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to", "onClick"])
          ]),
          ($props.purchasedCopiesCount || $props.estimatedDeliveryAt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                ($props.purchasedCopiesCount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_base_icon, {
                        "icon-namespace": "ga",
                        name: "brand-outline",
                        class: "_mr-1"
                      }),
                      _createElementVNode("span", null, _toDisplayString($options.foundersText), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                ($props.estimatedDeliveryAt)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_base_icon, { name: "truck-fast" }),
                      _createElementVNode("span", _hoisted_11, _toDisplayString($options.estimatedDeliveryDateLabel), 1 /* TEXT */),
                      ($props.deliveryDateRemarks)
                        ? (_openBlock(), _createBlock(_component_tooltip, { key: 0 }, {
                            content: _withCtx(() => [
                              _createVNode(_component_content_renderer, { content: $props.deliveryDateRemarks }, null, 8 /* PROPS */, ["content"])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_base_icon, { name: "circle-info" })
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        ($options.isInstallmentInfoVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_localize, {
                  resource: _ctx.Resources.Product.RewardCardStretchPayGetItForText
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_display_currency_price, {
                      "format-key": "0",
                      tag: "span",
                      "reverse-tooltip-position": "",
                      "icon-classes": "gfu-icon--small",
                      "effective-price": $props.installmentCost,
                      class: "_flexinline _ai-c"
                    }, {
                      "effective-price": _withCtx(({ effectivePrice }) => [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(effectivePrice), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["effective-price"])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["resource"]),
                _createVNode(_component_tooltip, null, {
                  content: _withCtx(() => [
                    _createVNode(_component_display_currency_value, {
                      "display-tooltip": false,
                      tag: "span"
                    }, {
                      content: _withCtx(({ displayCurrency }) => [
                        _createTextVNode(_toDisplayString($options.getInstallmentTooltipText(displayCurrency)), 1 /* TEXT */)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($options.getInstallmentTooltipText(_ctx.currentCheckoutCurrency)), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_base_icon, {
                      name: "circle-info",
                      class: "_ml-1"
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _createVNode(_component_themed_image, {
                src: "/content/images/static/stretch-pay/installments-logo.svg",
                alt: "stretchPay",
                width: "91"
              })
            ]))
          : _createCommentVNode("v-if", true),
        ($options.hasAction)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _renderSlot(_ctx.$slots, "action")
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["id", "data-qa"]))
}